export default {"src":"/uk/_next/static/media/spot-remote-working.66c97c6b.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};